import { AuctionLightDTO } from 'models'
import { UniversalAuctionLight } from 'models/universalData'
import { isDateFuture } from './isDateFuture'

const getPlural = (num: number): string => (num === 1 ? '' : 's')

const generateAuctionLib = (auctionLight: AuctionLightDTO): UniversalAuctionLight => {
  if (!auctionLight.auctionDate) {
    return { ...auctionLight, lib: '-' }
  }

  if (isDateFuture(auctionLight.auctionDate)) {
    const reservesToIndicate = auctionLight.numberOfLotWithoutReserve
    if (!Number.isFinite(reservesToIndicate)) {
      return { ...auctionLight, lib: '-' }
    }
    return {
      ...auctionLight,
      lib: `${reservesToIndicate} réserve${getPlural(reservesToIndicate)} à indiquer`,
    }
  }

  const vehicleCount = auctionLight.numberOfLotInAuction
  if (!Number.isFinite(vehicleCount)) {
    return { ...auctionLight, lib: '-' }
  }

  return {
    ...auctionLight,
    lib: `${vehicleCount} véhicule${getPlural(vehicleCount)}`,
  }
}

export { generateAuctionLib }
